import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import { UiFormControlLabel, UiRadioGroup, UiRadio } from 'ui-components';
import { getCurrentSlice } from 'utils';
import { StyledSeenStatusFilter } from './SeenStatusFilter.styles';

const seenStatusOptions = [
  { titleKey: 'common:all', value: 'both' },
  { titleKey: 'filter:seenContent', value: 'true' },
  { titleKey: 'filter:unseenContent', value: 'false' },
];

/**
 * فیلتر وضعیت مشاهده مطالب
 */
export const SeenStatusFilter = ({ componentName, className }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const selectedValue = useSelector(
    (state) =>
      state[state.filterReducer.filtersContext].filters[componentName]
        .selectedValue
  );
  const reducerName = useSelector(
    (state) => state.filterReducer.filtersContext
  );
  const { setSelectedFilterValue } = getCurrentSlice(reducerName);

  const handleChange = (event) => {
    dispatch(
      setSelectedFilterValue({
        value: event.target.value,
        componentName,
      })
    );
  };

  return (
    <StyledSeenStatusFilter>
      <UiRadioGroup
        className={classNames('filter-seen-status', className)}
        value={selectedValue}
        onChange={(event) => handleChange(event)}
      >
        {seenStatusOptions.map(({ titleKey, value }) => (
          <UiFormControlLabel
            key={value}
            className='mr-0'
            label={t(titleKey)}
            data-testid={`filter-seen-status-${value}-label`}
            control={
              <UiRadio
                value={value}
                inputProps={{
                  'data-testid': `filter-seen-status-${value}-checkbox`,
                }}
              />
            }
          />
        ))}
      </UiRadioGroup>
    </StyledSeenStatusFilter>
  );
};

SeenStatusFilter.propTypes = {
  componentName: PropTypes.string.isRequired,
  className: PropTypes.string,
};
